import React, {useEffect, useState} from 'react';

import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';
import {TriggerAttachmentType} from 'src/openapi/models/TriggerAttachmentType';

import {Group} from '@pb/kit-component-group';
import {Loading, Types} from '@pb/kit-component-loading';

import {
    fileAttachmentFullscreenLoading,
    fileAttachmentFullscreenMedia,
    fileAttachmentLoading,
    fileAttachmentMedia,
} from './trigger-attachment.module.styl';

type Props = {
    isPreview: boolean,
    attachment: TriggerAttachment,
    controls?: boolean,
    setFullscreen: (attachment: TriggerAttachment | null) => void,
};

export const AttachmentMedia = (props: Props) => {
    const {
        isPreview,
        attachment,
        controls,
        setFullscreen,
    } = props;

    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(false);
    }, [attachment.name]);

    const isImage = attachment.type === TriggerAttachmentType.IMAGE;
    const attachmentUrl = isPreview && isImage
        ? `/api/attachments/content/${attachment.name}/preview`
        : `/api/attachments/content/${attachment.name}`;

    const mediaClassName = isPreview ? fileAttachmentMedia : fileAttachmentFullscreenMedia;

    const handleLoad = () => setIsLoaded(true);
    const handleLoadStart = () => setIsLoaded(false);

    const onClick = () => {
        setFullscreen(attachment);
    };

    return (
        <>
            {!isLoaded && (
                <Group
                    className={isPreview ? fileAttachmentLoading : fileAttachmentFullscreenLoading}
                    justify="center"
                    alignItems="center">
                    <Loading fast={true} type={isPreview ? Types.ICON : Types.NONE}/>
                </Group>
            )}
            {attachment.type === TriggerAttachmentType.VIDEO ? (
                <video
                    src={`/api/attachments/content/${attachment.name}/stream`}
                    controls={controls}
                    autoPlay={false}
                    onLoadStart={handleLoadStart}
                    onLoadedMetadata={handleLoad}
                    className={mediaClassName}
                    style={{opacity: +isLoaded}}
                    onClick={onClick}
                />
            ) : (
                <img
                    src={attachmentUrl}
                    alt={attachment.name}
                    onLoad={handleLoad}
                    onLoadStart={handleLoadStart}
                    className={mediaClassName}
                    style={{opacity: +isLoaded}}
                    onClick={onClick}
                />
            )}
        </>
    );
};
